// @flow
import React from 'react';
import Text from './Typography';

type CheckboxProps = {
  id: number,
  label: string,
  checked: boolean,
  onToggle: (evt: Event) => void,
  className: string
}

const Checkbox = ({ id, label, checked, onToggle, className }: CheckboxProps) => {
  const isChecked = checked;
  const checkboxClass = className || 'checkbox';
  return (
    <div
      className={`${checkboxClass}`}
      onChange={() => onToggle(id)}
      role='checkbox'
      tabIndex={0}
      aria-checked={isChecked}
      onKeyPress={(e) => {
        if (e.key === 'Enter') { onToggle(id); }
      }}
    >
      <label
        className={`${checkboxClass}-label`}
        htmlFor={`${checkboxClass}-item-${id}`}
      >
        <input
          className={`${checkboxClass}-input`}
          type='checkbox'
          id={`${checkboxClass}-item-${id}`}
          name={`${checkboxClass}-item-${id}`}
          value={id}
          checked={isChecked}
          key={id}
          readOnly
        />
        <span className={`${checkboxClass}-target-container`}>
          <span className={`${checkboxClass}-target`} />
        </span>
        {label && <Text paragraph className={`${checkboxClass}-text`}>{label}</Text>}
      </label>
    </div>
  );
};

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/shared/CheckboxInput.js